import { useQuery } from '@tanstack/react-query'

import { apiClient } from '../apiClient'

type Point = {
  x: number
  y: number
}

type AnnotationType = 'bounding_box' | 'dot' | 'polygon' | 'line' | 'crosshair'

type Annotation = {
  annotation_id: string
  area?: number
  colorIndex?: number
  engagement_level?: boolean
  image_id?: string
  image_idx?: number
  label: string
  'sparkai.id'?: string
  sublabels?: [] | string[]
  type: AnnotationType
  vertices: Point[]
  original_annotation_id?: string
}

type Engagement = {
  engagement_id: string
  metadata?: string
  program_id: string
  date_created: string
  date_closed?: string
  client_id?: string
  time_to_close?: number
  aggregate_resolution_id?: string
  beq_is_under_agreement?: boolean
  state: 'open' | 'closed' | 'in-progress'
  resolution?: {
    response: string
    annotations: Annotation[]
  }
  resolution_id?: string
  resolution_agreement_ids?: string[]
  subrequest_ids?: string[]
  annotations?: Annotation[]
  images: {
    image_id: string
    location: string
    thumbnail_sm_location: string
  }[]
  aggregate_resolution?: {
    answers: string[]
    response: string
  }
  program: {
    name: string
  }
}

export function useGetById(id?: string) {
  return useQuery({
    queryKey: ['engagement', id],
    queryFn: async () => {
      const { data } = await apiClient.get<Engagement>(`int/engagement/${id}`)
      return data
    },
    enabled: Boolean(id),
    staleTime: 5 * 60 * 1000,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
  })
}
